import { Accept } from "react-dropzone";

export const uploadAcceptCsvAndExcel: Accept = {
  "text/csv": [".csv"],
  "text/plain": [".csv"], // Some versions of MacOS report CSVs as text/plain https://react-dropzone.js.org/
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};
export const uploadAcceptImage: Accept = {
  "text/png": [".png"],
  "text/jpg": [".jpg"],
  "text/jpeg": [".jpeg"],
};

export const uploadAcceptImagePNG: Accept = {
  "text/png": [".png"],
};

export const uploadAcceptPdf: Accept = {
  "application/pdf": [".pdf"],
};

export const uploadAcceptJson: Accept = {
  "application/json": [".json"],
};
